export const commericalModel = {
    allIds: ['opex','capex'],
    byIds: {
     
        "opex": { id: "opex", value: 'OPEX', data: { min: 0, max: 60, duration: 'Months' } },
        "capex": { id: 'capex', value: 'CAPEX', data: { min: 0, max: 5, duration: 'Years' } },
    }
}